const MULTIPLIED_BY = " × ";

export function quantityWithUnit(quantity, unit) {
  const unitCarriesCount = /\d/.test(unit ?? "");

  return `${quantity}${unitCarriesCount ? MULTIPLIED_BY : " "}${unit ?? ""}`.trim();
}

export function quantityLessOnShipmentWithUnit(quantity, onShipment, unit) {
  if (!onShipment) return quantityWithUnit(quantity, unit);

  return quantityWithUnit(`${quantity} (\u2212 ${onShipment})`, unit);
}
